"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var GenericModal = function (props) {
    var modalRef = (0, react_1.createRef)();
    var open = props.open, onClose = props.onClose;
    var handleClick = function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    (0, react_1.useEffect)(function () {
        var closeEsc = function (e) {
            if (e.key === 'Escape')
                onClose();
        };
        window.addEventListener('keydown', closeEsc);
        return function () { return window.removeEventListener('keydown', closeEsc); };
    }, []);
    (0, react_1.useEffect)(function () {
        if (!modalRef.current)
            return;
        var modal = modalRef.current;
        var detectMousePosition = function (e) {
            if (open)
                return;
            var windowWidth = window.innerWidth, windowHeight = window.innerHeight, modalWidth = modal.offsetWidth, modalHeight = modal.offsetHeight, _x = e.clientX, _y = e.clientY;
            var x = _x - windowWidth / 2 + modalWidth / 2;
            var y = _y - windowHeight / 2 + modalHeight / 2;
            modal.style.transformOrigin = "".concat(x, "px ").concat(y, "px");
        };
        document.addEventListener('click', detectMousePosition);
        return function () {
            document.removeEventListener('click', detectMousePosition);
        };
    }, [open]);
    return (react_1.default.createElement(ModalWrapper, { "$open": open, onClick: handleClick },
        react_1.default.createElement(ModalContent, { id: "modal-content", ref: modalRef, "$open": open, "$clear": props.clear, onClick: function (e) {
                e.stopPropagation();
            } }, props.children)));
};
var ModalWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.2s;\n\n  ", "\n"], ["\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.2s;\n\n  ", "\n"])), function (props) {
    return props.$open &&
        "\n      opacity: 1;\n      pointer-events: all;\n  ";
});
var ModalContent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 360px;\n  padding: 0 24px 24px;\n  border-radius: 10px;\n  background-color: white;\n  transform: scale(0.2);\n  transition: transform 0.2s;\n\n  ", "\n  ", "\n"], ["\n  width: 360px;\n  padding: 0 24px 24px;\n  border-radius: 10px;\n  background-color: white;\n  transform: scale(0.2);\n  transition: transform 0.2s;\n\n  ", "\n  ", "\n"])), function (props) { return props.$open && 'transform: scale(1);'; }, function (props) { return props.$clear && 'width: fit-content; padding: 0;'; });
exports.default = GenericModal;
var templateObject_1, templateObject_2;
